<script>
    import { isMobile, apiUrl } from "@/utils";

    export default {
        name: "HomePlantsCard",
        props: {
            plant: Object,
            isSlide: Boolean,
        },
        data() {
            return {
                isFadeUpPopover: false,
            };
        },
        methods: {
            isMobile,
            apiUrl,
            onMouseEnter() {
                if (!isMobile(992)) {
                    const elementTop =
                        this.$refs.scalesParametersCard.getBoundingClientRect().top;
                    const middleOfScreen = window.innerHeight / 2;

                    this.isFadeUpPopover = elementTop >= middleOfScreen;
                }
            },
        },
    };
</script>

<template>
    <div
        class="home-plants-card"
        :class="{ 'is-slide': isSlide }"
        ref="scalesParametersCard"
        @mouseenter="onMouseEnter"
    >
        <div class="home-plants-card__inner">
            <div class="home-plants-card__icon" :class="{ 'js-lazy-load': !isSlide }">
                <img
                    :class="{ 'swiper-lazy': isSlide }"
                    :data-src="apiUrl(plant.image)"
                    :alt="plant.title"
                />
            </div>
            <div class="home-plants-card__header">
                <span class="home-plants-card__title">{{ plant.title }}</span>
                <span class="home-plants-card__time">
                    <img class="icon" src="/static/igarden/home/time.svg" alt="" />
                    {{ plant.subtitle }}
                </span>
            </div>
        </div>

        <div v-if="isSlide" class="home-plants-card__text" v-html="plant.text"></div>

        <div
            v-if="!isSlide"
            class="home-plants-card__popover"
            :class="{ 'home-plants-card__popover--fade-up': isFadeUpPopover }"
        >
            <div class="home-plants-card__popover-header">
                <img class="image" :src="apiUrl(plant.image)" :alt="plant.title" />
                <div class="home-plants-card__popover-text">
                    <span class="home-plants-card__title">{{ plant.title }}</span>
                    <span class="home-plants-card__time">
                        <img class="icon" src="/static/igarden/home/time.svg" alt="" />
                        {{ plant.subtitle }}
                    </span>
                </div>
            </div>
            <div class="home-plants-card__text" v-html="plant.text"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .home-plants-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        padding: 12px 16px 24px;
        background-color: #fff;
        border-radius: 40px;
        box-shadow: 0 0 20px rgba(63, 158, 211, 0.15);
        &.is-slide {
            box-shadow: 0 0 20px rgba(76, 119, 68, 0.15);
        }
        @include bp($bp-desktop-sm) {
            position: relative;
            display: block;
            padding: 16px;
            border-radius: var(--border-xl);
            box-shadow: none;
            &:hover {
                .home-plants-card__popover {
                    visibility: visible;
                    opacity: 1;
                    transform: scale(1);
                    filter: blur(0);
                }
            }
        }
    }

    .home-plants-card__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
        }
    }

    .home-plants-card__icon {
        width: 146px;
        height: 93px;
        margin: 0 auto 12px;
        border-radius: var(--border-md);
        img {
            opacity: 0;
            transform: scale(0.9);
            transition: opacity 0.2s ease-in, transform 0.2s ease-in;
            &[lazy="loaded"],
            &.swiper-lazy-loaded {
                opacity: 1;
                transform: scale(1);
            }
        }

        @include bp($bp-desktop-sm) {
            margin: 0 16px 0 0;
        }
    }

    .home-plants-card__header {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        @include bp($bp-desktop-sm) {
            display: block;
        }
    }

    .home-plants-card__title {
        display: block;
        margin-right: 12px;
        margin-bottom: 12px;
        font-family: var(--secondary-font);
        font-size: 18px;
        font-weight: 700;
        line-height: 20px;

        @include bp($bp-desktop-sm) {
            margin-right: 0;
        }
    }

    .home-plants-card__time {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        padding-top: 2px;
        color: #9ec745;
        font-family: var(--secondary-font);
        font-size: 14px;
        font-weight: 700;
        line-height: 18px;
        white-space: nowrap;
        img.icon {
            @include box(16px);
            margin-right: 3px;
        }
    }

    .home-plants-card__text {
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            display: none;
            font-size: 16px;
            text-align: left;
        }
    }

    .home-plants-card__popover {
        display: none;

        @include bp($bp-desktop-sm) {
            position: absolute;
            z-index: 10;
            top: -10px;
            left: -10px;
            right: -10px;
            display: block;
            padding: 24px;
            background-color: inherit;
            border-radius: inherit;
            box-shadow: 0 0 20px rgba(63, 158, 211, 0.15);
            visibility: hidden;
            opacity: 0;
            transform: scale(0.9);
            filter: blur(3px);
            transition: opacity 0.25s ease-in, visibility 0.25s ease-in,
                transform 0.25s ease-in, filter 0.25s ease-in;

            .home-plants-card__text {
                display: block;
            }
            .home-plants-card__time {
                margin-bottom: 0;
            }
        }

        .home-plants-card__title {
            margin-bottom: 0;
            margin-right: 18px;
            padding: 0;
            text-align: left;
        }
    }

    .home-plants-card__popover--fade-up {
        top: auto;
        bottom: -10px;
    }

    .home-plants-card__popover-header {
        img.image {
            width: 75px;
            margin-right: 8px;
        }
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
        }
    }

    .home-plants-card__popover-text {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
